var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 151,
    viewBox: "0 0 187 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.902 0.399996C116.402 0.399996 98.7016 13 93.3016 25C87.9016 13 70.2016 0.399996 50.7016 0.399996C34.5016 0.399996 19.8016 8.8 16.2016 14.2L15.9016 0.999997L0.00156343 1.29999L0.301563 50.2C0.301563 49.3 0.00156343 51.7 0.00156343 54.7V151H15.9016V54.7C15.9016 33.1 31.2016 16.3 50.7016 16.3C70.2016 16.3 85.2016 33.1 85.2016 54.7V151H101.402V54.7C101.402 33.1 116.402 16.3 135.902 16.3C155.702 16.3 170.702 33.1 170.702 54.7V151H186.602V54.7C186.602 25 163.502 0.399996 135.902 0.399996Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerM);
export default __webpack_public_path__ + "static/media/LOWER_M.1c2a04809ed47f4b633883e782a4ade1.svg";
export { ForwardRef as ReactComponent };